export default __webpack_public_path__ + "static/media/Dheeraj-Khandelwal.59c82c8f.jpg";